module.exports = __webpack_public_path__ + "img/rhodium@2x.8b05dbd.webp";